import { registerPlugin } from '@capacitor/core';

/**
 * Bridge to the native InAppReview plugin (ios/App/App/InAppReviewPlugin.swift,
 * android/.../InAppReviewPlugin.java). It talks to the store, so it also
 * reports how this install was distributed (getInstallEnvironment), which
 * analytics uses to keep debug, TestFlight and sideloaded builds out.
 * Registered once here, on first use: Capacitor refuses a second
 * registration, and analytics imports this module on every platform.
 */
export type NativeInstallChannel =
  | 'debug'
  | 'simulator'
  | 'testflight'
  | 'app_store'
  | 'play_store'
  | 'sideload'
  | 'other';

export interface NativeInstallEnvironment {
  channel: NativeInstallChannel;
  debug: boolean;
  platform: string;
}

export interface NativeInAppReviewPlugin {
  isAvailable(): Promise<{ available: boolean; platform: string }>;
  requestReview(options?: { reason?: string }): Promise<{ requested: boolean; platform: string }>;
  /** Added after iOS 3.14.37 / Android 4.1.13; older binaries reject as unimplemented. */
  getInstallEnvironment(): Promise<NativeInstallEnvironment>;
}

let plugin: NativeInAppReviewPlugin | null = null;

export function getNativeInAppReviewPlugin(): NativeInAppReviewPlugin {
  if (!plugin) plugin = registerPlugin<NativeInAppReviewPlugin>('InAppReview');
  return plugin;
}
